module.exports = "/images/vendor/vue-paycard/src/25.jpg?f281d1d2da37b0cf579abcdfdeee2db5";